// countUnitInfo — "is this canonical counted in discrete pieces?"
//
// Tiny read helper for the count-aware quantity feature ("how many
// chops?"). Reads through findIngredient (the sanctioned canonical
// resolver) so bundled, synthetic, and overlay-enriched canonicals
// all resolve the same way.
//
//   isCountDefault — the canonical's defaultUnit is "count"
//                    (lamb_chop, eggs): the natural way to buy and
//                    track it is by the piece.
//   isCountable    — the unit ladder carries a "count" entry at all
//                    (many by-weight canonicals still allow counting).
//   label          — the count unit's display label ("chops"), or
//                    null when the ladder has no count entry.
//
// Null-safe: unknown / missing canonicals return all-false / null.

import { findIngredient } from "../data/ingredients";

const NONE = Object.freeze({ isCountDefault: false, isCountable: false, label: null });

export function countUnitInfo(canonicalId) {
  if (!canonicalId) return NONE;
  const ing = findIngredient(canonicalId);
  if (!ing) return NONE;
  const countUnit = Array.isArray(ing.units)
    ? ing.units.find((u) => u?.id === "count")
    : null;
  return {
    isCountDefault: ing.defaultUnit === "count",
    isCountable: !!countUnit,
    label: countUnit?.label || null,
  };
}
